export function processOverview(module, mapContainer) {
  let overviewTitle = mapContainer.find('h2.acalog-program-core-name:contains("Program Description")').first();

  if (!overviewTitle.length) {
    return;
  }

  let descriptionContainer = overviewTitle.next(".acalog-program-core-description");

  if (!descriptionContainer.length) {
    return;
  }

  let overviewDataContainer = module.find(".js-overviewData");
  overviewDataContainer.html(descriptionContainer.html());
}

export function processAosOverview(module, mapContainer) {
  let overviewDataContainer = module.find(".js-overviewData");
  overviewDataContainer.html(mapContainer);
}